import { fetchData, postData, putData } from "../utils/apiUtils";
export const get_department = async () => {
  const responseData = await fetchData("employee/department");
  return responseData;
};

export const all_employee = async () => {
  const responseData = await fetchData("employee");
  return responseData;
};

export const unassigned_managers = async () => {
  const responseData = await fetchData("employee/unassigned/managers");
  return responseData;
};
export const get_employee = async (id) => {
  const responseData = await fetchData(
    `employee/byid?id=${encodeURIComponent(id)}`
  );
  return responseData;
};

export const get_employeeDetail = async (emp_id) => {
  const responseData = await fetchData(
    `employee/employee_detail/byid?emp_id=${encodeURIComponent(emp_id)}`
  );
  return responseData;
};

export const RegisterEmployee = async (employeeData) => {
  const responseData = await postData(
    "employee/register_employee",
    employeeData
  );
  return responseData;
};

export const updateEmployeeData = async (data) => {
  const responseData = await putData("employee/update", data);
  return responseData;
};
export const updateTin = async (data) => {
  const responseData = await putData("people/tin", data);
  return responseData;
};

// employee detail
export const get_employeeSalary = async (step, grade) => {
  const responseData = await fetchData(
    `employee/scale/salary?step=${encodeURIComponent(
      step
    )}&grade=${encodeURIComponent(grade)}`
  );
  return responseData;
};

// employee detail
export const get_SalaryScale = async () => {
  const responseData = await fetchData(`employee/scale`);
  return responseData;
};
export const RegisterSlaryScale = async (employeeData) => {
  const responseData = await postData("employee/scale/register", employeeData);
  return responseData;
};

export const get_empDetail_dropDown_data = async () => {
  const responseData = await fetchData(`employee/employee_detail/support_data`);
  return responseData;
};

export const get_branch_dropDown_data = async () => {
  const responseData = await fetchData(`employee/branch`);
  return responseData;
};

export const get_branch_data = async () => {
  const responseData = await fetchData(`employee/branch`);
  return responseData;
};

export const get_branch_byId = async (branchId) => {
  const responseData = await fetchData(
    `employee/branch/byid?id=${encodeURIComponent(branchId)}`
  );
  return responseData;
};

export const RegisterBranch = async (branchData) => {
  const responseData = await postData("employee/branch/register", branchData);
  return responseData;
};

export const updateBranchManager = async (BranchData) => {
  const responseData = await putData(
    "employee/branch/update/manager",
    BranchData
  );
  return responseData;
};
export const updateBranch = async (BranchData) => {
  const responseData = await putData("employee/branch/update", BranchData);
  return responseData;
};
export const get_employee_data = async () => {
  const responseData = await fetchData("employee");
  return responseData;
};

export const get_task_data = async () => {
  const responseData = await fetchData("project/project_job");
  return responseData;
};

export const get_task_detaile = async (task_id) => {
  const responseData = await fetchData(
    `employee/gigworker/task/participants?id=${encodeURIComponent(task_id)}`
  );
  return responseData;
};

export const get_task_participants = async (task_id) => {
  const responseData = await fetchData(
    `employee/gigworker/task/participants?id=${encodeURIComponent(task_id)}`
  );
  return responseData;
};

export const get_task_target = async () => {
  const responseData = await fetchData(`employee/task-target`);
  return responseData;
};

export const RegisterTaskAssignment = async (projectData) => {
  const responseData = await postData(
    "employee/gigworker/task/register",
    projectData
  );
  return responseData;
};

export const RegisterrEmpDetail = async (employeeData) => {
  const responseData = await postData(
    "employee/employee_detail/register",
    employeeData
  );
  return responseData;
};

export const RegisterAtttendance = async (attendanceData) => {
  const responseData = await postData(
    "employee/employee_attendance/bulk/checkin",
    attendanceData
  );
  return responseData;
};

export const get_attendance_data = async (branch_id, date) => {
  const responseData = await fetchData(
    `employee/employee_attendance/bybranch?branch_id=${encodeURIComponent(
      branch_id
    )}&date=${encodeURIComponent(date)}`
  );
  return responseData;
};

export const get_branch_attendance_report = async (
  branch_id,
  fromdate,
  todate
) => {
  const responseData = await fetchData(
    `employee/employee_attendance/reports/branch-summary?branch_id=${encodeURIComponent(
      branch_id
    )}&from_date=${encodeURIComponent(fromdate)}&to_date=${encodeURIComponent(
      todate
    )}`
  );
  return responseData;
};

export const get_branch_employee_attendance_report = async (
  branch_id,
  fromdate,
  todate
) => {
  const responseData = await fetchData(
    `employee/employee_attendance/reports/branch-employees?branch_id=${encodeURIComponent(
      branch_id
    )}&from_date=${encodeURIComponent(fromdate)}&to_date=${encodeURIComponent(
      todate
    )}`
  );
  return responseData;
};
export const get_all_employee_attendance_report = async (fromdate, todate) => {
  const responseData = await fetchData(
    `employee/employee_attendance/reports/all-employees?from_date=${encodeURIComponent(
      fromdate
    )}&to_date=${encodeURIComponent(todate)}`
  );
  return responseData;
};
export const RegisterMyTaskReport = async (reportData) => {
  const responseData = await postData(
    "employee/task-record/register",
    reportData
  );
  return responseData;
};

export const RegisterTaskReport = async (taskData) => {
  const responseData = await postData(
    "employee/task-record/bulk/register",
    taskData
  );
  return responseData;
};
export const updateMyTaskReport = async (reportData) => {
  const responseData = await putData("employee/task-record/update", reportData);
  return responseData;
};

export const get_all_employee_task_report = async (
  fromdate,
  todate,
  taskid
) => {
  const responseData = await fetchData(
    `employee/task-record/score/report?from_date=${encodeURIComponent(
      fromdate
    )}&to_date=${encodeURIComponent(todate)}&task_id=${encodeURIComponent(
      taskid
    )}`
  );
  return responseData;
};
export const reviewTaskReport = async (taskData) => {
  const response = await putData("employee/task-record/review", taskData);
  return response;
};

export const get_my_task = async (emp_id) => {
  const responseData = await fetchData(
    `employee/gigworker/task/employee?emp_id=${encodeURIComponent(emp_id)}`
  );
  return responseData;
};

export const get_branch_tasks = async (branch = null) => {
  let url = `employee/gigworker/task`;
  if (branch) {
    url = `${url}?branch_id=${encodeURIComponent(branch)}`;
  }
  const responseData = await fetchData(url);
  return responseData;
};

export const get_my_task_status = async (emp_id) => {
  const responseData = await fetchData(
    `employee/task-record/employee?emp_id=${encodeURIComponent(emp_id)}`
  );
  return responseData;
};

export const get_Branch_task_requests = async (branch_id) => {
  const responseData = await fetchData(
    `employee/task-record/employee?branch_id=${encodeURIComponent(branch_id)}`
  );
  return responseData;
};
export const get_my_task_report_bystatus = async (employee_id) => {
  const responseData = await fetchData(
    `employee/task-record/my-task/report?emp_id=${encodeURIComponent(
      employee_id
    )}`
  );
  return responseData;
};

export const RegisterEmpEducation = async (empData) => {
  const responseData = await postData(
    "employee/employee_education/register",
    empData
  );
  return responseData;
};

export const RegisterEmpExperience = async (empData) => {
  const responseData = await postData(
    "employee/employee_experience/register",
    empData
  );
  return responseData;
};

export const get_employeeReference = async (emp_id) => {
  const responseData = await fetchData(
    `employee/employee_reference/byempid?emp_id=${encodeURIComponent(emp_id)}`
  );
  return responseData;
};

export const RegisterEmpReference = async (empData) => {
  const responseData = await postData(
    "employee/employee_reference/register",
    empData
  );
  return responseData;
};

// labor List
export const get_labor_data = async () => {
  const responseData = await fetchData(`employee/labor`);
  return responseData;
};

export const RegisterLabor = async (empData) => {
  const responseData = await postData("employee/labor/register", empData);
  return responseData;
};
export const get_target_taype = async () => {
  const responseData = await fetchData(`employee/target-type`);
  return responseData;
};
export const get_branch_target = async () => {
  const responseData = await fetchData(`employee/branch-target`);
  return responseData;
};

export const RegisterBranchTarget = async (BranchTarget) => {
  const responseData = await postData(
    "employee/branch-target/register",
    BranchTarget
  );
  return responseData;
};

export const UpdateBranchTarget = async (BranchTarget) => {
  const responseData = await putData(
    "employee/branch-target/update",
    BranchTarget
  );
  return responseData;
};

export const RegisterTaskTarget = async (taskTarget) => {
  const responseData = await postData(
    "employee/task-target/register",
    taskTarget
  );
  return responseData;
};

export const UpdateTaskTarget = async (Data) => {
  const responseData = await putData("employee/task-target/update", Data);
  return responseData;
};

export const get_new_employee = async () => {
  const responseData = await fetchData("employee/user/get/unassigned/employee");
  return responseData;
};
export const getRole = async () => {
  const url = `employee/role/getall`;
  const responseData = await fetchData(url);
  return responseData;
};
